import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

import CheckBoxInputComponent from './CheckBoxInputComponent';

interface Props {
  question: FlowsQuestion;
}

const CheckboxInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  ...otherProps
}) => {
  //logic to choocse between multiple or one checkbox needs to come here
  switch (null) {
    default:
      return <CheckBoxInputComponent {...otherProps} />;
  }
};

export default CheckboxInputPicker;
